import isMobileLib from 'is-mobile'

export const isMobileOrTablet = isMobileLib({ tablet: true, featureDetect: true })
export const isChromeOnAppleDevice = Boolean(navigator.userAgent.match(/CriOS/))
export const isFirefoxOnAppleDevice = Boolean(navigator.userAgent.match(/FxiOS/))
export const isOperaTouchOnAppleDevice = Boolean(navigator.userAgent.match(/OPT/))

export const createMobileReturnUrl = () => {
  if (isChromeOnAppleDevice) {
    return encodeURIComponent('googlechrome://')
  }
  if (isFirefoxOnAppleDevice) {
    return encodeURIComponent('firefox://')
  }
  if (isOperaTouchOnAppleDevice) {
    return encodeURIComponent(`${window.location.href.replace('http', 'touch-http')}#initiated=true&testingType=identify`)
  }

  return encodeURIComponent(`${window.location.href}#initiated=true&testingType=identify`)
}
